<script setup lang="ts">
const { trustpilotReview } = useDkConfig()
</script>

<template>
    <div v-if="trustpilotReview" class="trustpilot-review">
        <div class="trustpilot-review__content">
            <NuxtImg
                preset="local"
                provider="cloudflare"
                :src="trustpilotReview.avatar"
                width="200"
                height="200"
                densities="x2"
                class="trustpilot-review__avatar"
                :alt="trustpilotReview.name"
                decoding="async"
                loading="lazy"
            />

            <TrustpilotWidget class="trustpilot-review__widget" type="detailed" theme="dark" />
            <div class="trustpilot-review__quote-sign">
                "
            </div>

            <!-- eslint-disable vue/no-v-html Source of trustpilotReview is safe (from nuxt.config) -->
            <div
                class="trustpilot-review__quote"
                v-html="trustpilotReview.quote"
            />
            <div
                class="trustpilot-review__name"
                v-html="trustpilotReview.name"
            />
            <!-- eslint-enable vue/no-v-html -->
        </div>
    </div>
</template>

<style scoped lang="scss">
.trustpilot-review {
    position: relative;
    padding: 40px 36px;
    color: $white;
    background-color: #00395e;

    @media (min-width: $screen-xs) {
        margin: 30px -15px -15px -15px;
    }

    @media (min-width: $screen-md) {
        margin: 30px -30px -30px -30px;
        padding: 50px 0;
    }

    @media (min-width: $screen-lg) {
        margin: 30px 0 0;
        border-radius: 10px;
    }

    &__content {
        display: grid;
        position: relative;
        grid-template:
            'avatar' 200px
            'rating'
            'rating'
            'quote-sign'
            'quote'
            'name' auto / 1fr;
        grid-gap: 12px;
        max-width: 320px;
        margin: 0 auto;

        @media (min-width: $screen-md) {
            grid-template:
                'avatar quote-sign quote quote quote'
                'avatar quote-sign name rating rating' 1fr / 140px auto 1fr 1fr 1fr;
            grid-gap: 12px 24px;
            max-width: 680px;
        }
    }

    &__logo {
        grid-area: logo;
        justify-self: center;

        @media (min-width: $screen-md) {
            align-self: end;
            margin-right: -26px; /* pull logo closer to rating */
            margin-bottom: 2px; /* alignment */
            justify-self: end;
        }
    }

    &__widget {
        grid-area: rating;
        justify-self: center;

        @media (min-width: $screen-md) {
            align-self: end;
            justify-self: end;
            margin-top: 10px;
        }
    }

    &__quote-sign {
        grid-area: quote-sign;
        color: #00b67a;
        font-family: 'TimesNewRoman', 'Times New Roman', 'Times', 'Baskerville', 'Georgia', serif;
        font-size: 60px;
        height: 36px;
        line-height: 1;
        font-weight: 700;
        justify-self: center;
        margin-left: -10px;

        @media (min-width: $screen-md) {
            justify-self: auto;
        }
    }

    &__avatar {
        left: 0;
        grid-area: avatar;
        width: 200px;
        height: 200px;
        border: 3px solid $white;
        border-radius: 50%;
        background: rgba($blue, 0.2);
        object-position: 10px;
        justify-self: center;

        @media (min-width: $screen-md) {
            position: absolute;
            bottom: 0;
            transform: translate3d(-20px, 50px, 0);
            border: none;
            border-radius: 0;
            background: transparent;
            object-position: 0;
        }
    }

    &__quote {
        grid-area: quote;
        text-align: center;
        justify-self: center;

        @media (min-width: $screen-md) {
            margin-top: 12px;
            text-align: left;
            justify-self: stretch;
        }
    }

    &__name {
        grid-area: name;
        font-size: $font-size-sm;
        font-weight: $text-bold;
        margin: 10px 0 0;
        justify-self: center;

        @media (min-width: $screen-md) {
            align-self: end;
            justify-self: stretch;
            margin: 0 0 25px;
            font-weight: $text-semi-bold;
        }
    }
}
</style>
